module.exports = __webpack_public_path__ + "static/media/loading_dark.384927a7.svg";